import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

export const CheckboxesContainer = styled.div<{ theme: ICustomTheme }>`
  padding-left: ${({ theme }) => theme.spacing(2)}px;
  margin-top: ${({ theme }) => theme.spacing(3)}px;
`;

export const InputsContainer = styled.div<{ theme: ICustomTheme }>`
  margin-top: ${({ theme }) => `${theme.spacing(2)}px`};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${theme.spacing(2)}px`};
  > div {
    width: 100%;
  }
  .MuiInputBase-input {
    font-size: 16px;
    ${({ theme }) => theme.breakpoints.down('sm')} {
      font-size: 14px;
    }
  }
`;

export const InputsInline = styled.div<{ theme: ICustomTheme }>`
  display: flex;
  justify-content: space-around;
  width: 100%;
  gap: ${({ theme }) => `${theme.spacing(3)}px`};
  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: ${({ theme }) => `${theme.spacing(2)}px`};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  margin-top: 2rem;
`;

export const RequiredFieldsHint = styled.p<{ theme: ICustomTheme }>`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: ${({ theme }) => `${theme.spacing(1)}px 0 0 0`};
  font-style: italic;
`;

export const AddressSectionContainer = styled.fieldset<{
  theme: ICustomTheme;
}>`
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
  padding: ${({ theme }) =>
    `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`};
  margin-top: ${({ theme }) => `${theme.spacing(2)}px`};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${theme.spacing(2)}px`};

  > legend {
    padding: 0 ${({ theme }) => `${theme.spacing(1)}px`};
    font-size: 1.2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

export const PostalCodeCityInline = styled.div<{ theme: ICustomTheme }>`
  display: flex;
  width: 100%;
  gap: ${({ theme }) => `${theme.spacing(3)}px`};

  > div:first-of-type {
    flex: 0 0 30%;
    min-width: 0;
  }

  > div:last-of-type {
    flex: 1 1 70%;
    min-width: 0;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: ${({ theme }) => `${theme.spacing(2)}px`};

    > div:first-of-type,
    > div:last-of-type {
      flex: 1 1 100%;
    }
  }
`;

// --- Checkbox FormControlLabel with top-aligned checkbox ---

export const CheckboxErrorWrapper = styled.div<{ theme: ICustomTheme }>`
  margin-left: ${({ theme }) => theme.spacing(-1.5)}px;
  margin-bottom: ${({ theme }) => theme.spacing(1.5)}px;
`;

// --- Server errors container ---

export const ServerErrorsContainer = styled.div<{ theme: ICustomTheme }>`
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`;

// --- Login link container ---

export const LoginLinkContainer = styled.div`
  text-align: center;
`;

// --- Checkbox FormControlLabel with top-aligned checkbox ---

export const CheckboxLabel = styled.div`
  .MuiFormControlLabel-root {
    align-items: flex-start;
  }
`;

// --- Styled helpers (subscribe-form-specific) ---

export const FormContainer = styled.div<{ theme: ICustomTheme }>`
  margin-top: ${({ theme }) => theme.spacing(3)}px;
`;

export const ErrorCaption = styled.span`
  display: block;
  font-size: 0.75rem;
`;

export const TooltipContainer = styled.div<{ theme: ICustomTheme }>`
  display: flex;
  align-items: center;
  margin-left: ${({ theme }) => theme.spacing(1)}px;
`;
